import {forEach, pipe} from 'ramda';
import {querySelectorAll} from '../dom-utils';
import filterUppercase from '../functions/filterUppercase';

export default pipe(
    querySelectorAll,
    forEach(filterUppercase)
);
